import React from "react";
import { Form, Row, Col, Modal, notification } from "antd";
import liracrypt from "../components/Liracrypt/liracrypt";
import Button from "../components/ReportFormGenerator/Button/Button";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../components/ApiErrorComp/SessionError";
import InputIdentify from "./InputCreater/InputCreater";
import StAddNew from "./DSeries/StAddNew";
import RoutePage from "../components/RoutePage";
import { LoadingOutlined } from "@ant-design/icons";

import PhantomPrime from "./PhantomPrime";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import ZenFormInput from "./InputCreater/ZenFormInput";

function HModal({
  btnData,
  submitBtnId,
  modalData,
  modalAction,
  isModalVisible,
  setIsModalVisible,
  action,
  modalMethod,
  fetch,
  extraData,
  urlData,
  mergeData,
  setState,
  onEditFinish,
  onDeleteFinish,
  preventSubmitBtnClick,
  onResponse,
  modalLoading,
  barCode
}) {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [apiMethod, setApiMethod] = React.useState(null);
  const [apiUrl, setApiUrl] = React.useState(null);
  const [element, setElement] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [id, setId] = React.useState(null);
  const [loginError, setLoginError] = React.useState(false);
  const [header, setHeader] = React.useState("");

  // const [callMade, setCallMade] = React.useState(false);

  let dateSets = {};

  const LocalDict = [];
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker"];

  const [form] = Form.useForm();

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
    if (!preventSubmitBtnClick) {
      if (document.getElementById("submitButtonForm")) {
        document.getElementById("submitButtonForm").click();
      }
    }
  };

  React.useEffect(() => {
    if (!isModalVisible) return;
    // console.log(action, modalMethod);
    if (action && modalMethod && action[modalMethod]) {
      let headerTitle = action.pageTitle || action[modalMethod].pageTitle || action.modalHeader || action[modalMethod].modalHeader || 'Modal XXX';

      setApiMethod(action.method ? action.method : action[modalMethod].method);
      setHeader(headerTitle);
      setApiUrl(action.api || action.url || action[modalMethod].api || action[modalMethod].url);
      setElement(
        action.modalElements
          ? action.modalElements
          : action[modalMethod].modalElements
      );

      if (modalData) {
        setId(modalData["_id"]);
      }
    }
  }, [isModalVisible, modalLoading]);

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    // setCallMade(false);
    setIsModalVisible(false);
  };

  const onFinish = (valueData) => {
    // if (!callMade) {
    setLoading(true);
    let value = { ...urlData, ...valueData };
    if (btnData) {
      value = { ...value, btnData: { ...btnData } };
    }
    Object.keys(value).forEach((data) => {
      if (data in dateSets) {
        value[data] = value[data].format(dateSets[data]).toString();
      }
    });
    if (id) {
      value["_id"] = id;
    }

    Object.keys(value).forEach((key, i) => {
      // console.log(key, LocalDict[key]);
      if (value[key]) {
        if (Array.isArray(value[key]) && LocalDict[key]) {
          value[
            LocalDict["data_index_from"]
              ? LocalDict["data_index_from"]
              : "from"
          ] = dayjs(value[key][0]).format(LocalDict[key]).toString();
          value[
            LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"
          ] = dayjs(value[key][1]).format(LocalDict[key]).toString();
          delete value[key];
        } else {
          if (LocalDict[key]) {
            value[key] = dayjs(value[key]).isValid()
              ? dayjs(value[key]).format(LocalDict[key]).toString()
              : value[key];
          }
        }
      }
    });

    let sendData;
    if (extraData) {
      if (!mergeData) {
        sendData = { ...searchParams, modalData: value, stableData: extraData };
      }
      sendData = { ...searchParams, ...extraData, ...value };
    } else {
      sendData = { ...value };
    }
    sendData.barCode = barCode;
    let formData = new FormData();
    Object.keys(sendData).forEach((key) => {
      formData.append(key, sendData[key]);
    });
    if (apiMethod === "PATCH") {
      if (action[modalMethod]?.dataType === 'formData' || modalAction?.dataType === 'formData') {
        liracrypt
          .fileUploadPatch(apiUrl, formData)
          .then((res, req) => {
            // console.log(res.data);
            setLoading(false);
            if (res.data.isSuccess) {
              // setCallMade(true);
              openNotificationWithIcon("success", res.data.message);
              if (!onEditFinish) {
                setIsModalVisible(false);
              }
              if (onEditFinish) {

                onEditFinish({ data: res.data.data });
              }
              if (setState) {
                setState(res.data.data);
              }
              if (onResponse) {
                onResponse({ onlyPostSubmitAction: true, response: res, data: res.data });
              }
            } else {
              openNotificationWithIcon("error", res.data.message);
            }
          })
          .catch((error) => {
            setLoading(false);
            if (error.response !== undefined) {
              if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .patch(apiUrl, { ...sendData })
          .then((res, req) => {
            // console.log(res.data);
            setLoading(false);
            if (res.data.isSuccess) {
              // setCallMade(true);
              openNotificationWithIcon("success", res.data.message);
              if (!onEditFinish) {
                setIsModalVisible(false);
              }
              if (onEditFinish) {
                onEditFinish({ data: res.data.data });
              }
              if (setState) {
                setState(res.data.data);
              }
              if (onResponse) {
                onResponse({ onlyPostSubmitAction: true, response: res, data: res.data });
              }
            } else {
              openNotificationWithIcon("error", res.data.message);
            }
          })
          .catch((error) => {
            setLoading(false);
            if (error.response !== undefined) {
              if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }
            }
          });
      }
    } else if (apiMethod === "POST") {
      if (action[modalMethod]?.dataType === 'formData' || modalAction?.dataType === 'formData') {
        liracrypt
          .uploadFile(apiUrl, formData)
          .then((res, req) => {
            // console.log(res.data);
            setLoading(false);
            if (res.data.isSuccess) {
              if (onResponse) {
                onResponse({ onlyPostSubmitAction: true, data: res.data });
              };

              openNotificationWithIcon("success", res.data.message);
            } else {
              openNotificationWithIcon("error", res.data.message);
            }
            setIsModalVisible(false);
          })
          .catch((error) => {
            setLoading(false);
            if (error.response !== undefined) {
              if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }
            }
          });
      } else {
        liracrypt
          .post(apiUrl, { ...sendData })
          .then(res => {
            // console.log(res.data);
            setLoading(false);
            if (res.data.isSuccess) {
              openNotificationWithIcon("success", res.data.message);
              if (onResponse) {
                onResponse({ onlyPostSubmitAction: true, data: res.data });
              };

            } else {
              openNotificationWithIcon("error", res.data.message);
            }
            setIsModalVisible(false);
          })
          .catch((error) => {
            setLoading(false);
            if (error.response !== undefined) {
              if (error.response.status !== 401) {
                ApiErrorComp(error.response.status);
              } else {
                setLoginError(true);
              }
            }
          });
      }
    } else if (apiMethod === "DELETE") {
      liracrypt
        .delete(apiUrl, sendData)
        .then((res, req) => {
          // console.log(res.data);
          setLoading(false);
          if (res.data.isSuccess) {
            if (onResponse) {
              onResponse({ onlyPostSubmitAction: true });
            }
            openNotificationWithIcon("success", res.data.message);
          } else {
            openNotificationWithIcon("error", res.data.message);
          }
          setIsModalVisible(false);
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
    // }
  };

  const deleteYes = () => {
    setLoading(true);
    liracrypt
      .delete(action[modalMethod]["url"], { ...searchParams, ...extraData, _id: modalData?._id })
      .then((res, req) => {
        if (res.data.isSuccess) {
          onDeleteFinish();
          setLoading(false);
          openNotificationWithIcon("success", res.data.message);
        } else {
          setLoading(false);
          openNotificationWithIcon("error", res.data.message);
        }
        setIsModalVisible(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        openNotificationWithIcon("error", "Oops ! Something went Wrong...");
      });
  };

  const InputClassify = (data, index) => {
    // console.log("HM", data);
    // console.log(data, modalData[data["data_index"]], "HM");
    if (dtArray.includes(data["typ"])) {
      // console.log(data["format"], "Phantom");
      LocalDict[data["data_index"]] = data["format"]
        ? data["format"]
        : "YYYY-MM-DD hh:mm:ss";
      LocalDict["data_index_from"] = data["data_index_from"];
      LocalDict["data_index_to"] = data["data_index_to"];
    }
    if (data.visible !== false) {
      return (
        <>
          <ZenFormInput
            multiSelect={data["multiSelect"]}
            urlData={{ ...urlData }}
            childType={data.childType}
            pageType={"zenForm"}
            header={data.header}
            footer={data.footer}
            labelColSpan={data["labelColSpan"]}
            style={data['style']}
            height={data['height']}
            layoutPosition="space-between"
            rows={data.rows}
            colSpan={24}
            name={data["data_index"]}
            form={form}
            pname={data["p_data_index"]}
            data={data}
            label={data["label"]}
            defaultValue={
              data["default"]
                ? data["default"]
                : modalData && modalData[data["data_index"]]
                  ? modalData[data["data_index"]]
                  : null
            }
            typ={data["typ"]}
            disabled={data["readOnly"]}
            source={data["source"]}
            sourceParams={{ ...urlData, ...data["sourceParams"] }}
            auxParams={data["auxParams"]}
            format={data["format"]}
            defaultKey={data["data_index"]}
            errorMessage={data["errorMessage"]}
            placeHolder={data["placeHolder"]}
            required={data["required"]}
            includeAll={data["includeAll"]}
            options={data["data"]}
            from={data["data_index_from"]}
            to={data["data_index_to"]}
            url={data["url"]}
            modalData={modalData ? modalData : null}
            modalKey={data["data_index"]}
            searchable={data["isSearchable"]}
            LocalDict={LocalDict}
            defaultFrom={
              data["defaultFrom"]
                ? modalData[data["defaultFrom"]]
                : null
            }
            defaultTo={
              data["defaultTo"]
                ? modalData[data["defaultTo"]]
                : null
            }
            extraData={extraData}
            children={data['children']}
          />
        </>
      );
    }
  };

  return (
    <div>
      {/* {console.log(modalMethod)} */}
      <SessionError visible={loginError} />
      {action[modalMethod] && modalMethod === "delete" ? (
        <>
          <Modal
            className={"zen-modal"}
            title={
              modalData["msgSuffixDataIndex"]
                ? action[modalMethod]["msgPrefix"] +
                modalData["msgSuffixDataIndex"]
                : action[modalMethod]["msgPrefix"]
            }
            open={isModalVisible}
            onOk={deleteYes}
            onCancel={() => setIsModalVisible(false)}
            okText="Yes"
            okButtonProps={{ loading: loading }}
            cancelText="No"
          >
            {/* {element ? <FormElement element={element} /> : <></>} */}
          </Modal>
        </>
      ) : (
        <></>
      )}
      {modalMethod === "view" ? (
        <>
          <Modal
            className={"zen-modal"}
            title={header ? header : "View Modal"}
            open={isModalVisible}
            style={{ minWidth: "1000px" }}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Submit"
            okButtonProps={{ loading: loading, hidden: true }}
            cancelButtonProps={{ hidden: true }}
          >
            <PhantomPrime
              colSpan={24}
              pageName="Report Stabler"
              urlEndpoint="/miscellaneous/pageconfig"
              urlData={{ dictName: "PhantomTemplate" }}
            />
          </Modal>
        </>
      ) : (
        <></>
      )}
      {modalMethod === "route" ? (
        <>
          <Modal
            className={"zen-modal"}
            title={header ? header : "View Modal"}
            open={isModalVisible}
            style={{ minWidth: "1000px" }}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Submit"
            okButtonProps={{ loading: loading, hidden: true }}
            cancelButtonProps={{ hidden: true }}
          >
            <RoutePage route={modalAction?.url} params={modalAction?.urlData} />
          </Modal>
        </>
      ) : (
        <></>
      )}
      {action[modalMethod] && (modalMethod === "approve" || modalMethod === 'edit') ? (
        <>
          <Modal
            className={"zen-modal"}
            title={header}
            open={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Submit"
            okButtonProps={{ loading: loading, hidden: true }}
            cancelButtonProps={{ hidden: true }}
          >
            {
              modalLoading ?
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //  minHeight: "80vh",
                  }}
                >
                  <LoadingOutlined
                    style={{ fontSize: 80, color: "#007bff" }}
                    spin
                  />
                </div> :
                element ? (
                  <div
                    className="AuditSection CreateAudit"
                    style={{ padding: "10px" }}
                  >
                    <div className="ThemeForm phantomzen form">
                      <Form
                        name="ReportForm"
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                        colon={false}
                        onFinish={onFinish}
                        size="large"
                      >
                        {element.map(InputClassify)}

                        <Button
                          submitBtnId={submitBtnId}
                          form={form}
                          marginLeft="70px"
                          loading={loading}
                          cancelButtonText={"Reset"}
                          submitButtonText={"Submit"}
                          resetButton={true}
                        />
                      </Form>
                    </div>
                  </div>
                ) : (
                  <></>
                )
            }
          </Modal>
        </>
      ) : (
        <>
          {action[modalMethod] && modalMethod === "dynamicModal" ? (
            <Modal
              className={"zen-modal"}
              title={header}
              open={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              okText="Submit"
              okButtonProps={{ loading: loading, hidden: true }}
              cancelButtonProps={{ hidden: true }}
            >
              <StAddNew
                colSpan={24}
                urlEndpoint={action[modalMethod]["url"]}
                urlMethod={action[modalMethod]["method"]}
                urlData={{
                  ...action[modalMethod]["data"],
                  doc: modalData,
                }}
                onCallFinish={() => {
                  setIsModalVisible(false);
                  document.getElementById("phantomPrimeSbmt").click();
                }}
              />
              {/* <Phantom
                colSpan={24}
                urlEndpoint={action[modalMethod]["url"]}
                urlMethod={action[modalMethod]["method"]}
                urlData={{
                  ...action[modalMethod]["data"],
                  doc: modalData,
                }}
              /> */}
            </Modal>
          ) : (
            <></>
          )}
        </>
      )}

      {/* {action[modalMethod] &&
      modalMethod !== "delete" &&
      modalMethod === "view" ? (
        <>
          {action[modalMethod] && modalMethod !== "view" ? (
            <Modal
              title={header}
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              okText="Submit"
              okButtonProps={{ loading: loading, hidden: true }}
              cancelButtonProps={{ hidden: true }}
            >
              {element ? <FormElement element={element} /> : <></>}
            </Modal>
          ) : (
            <>
              <Modal
                title={header}
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
                okButtonProps={{ loading: loading, hidden: true }}
                cancelButtonProps={{ hidden: true }}
              >
                <Phantom
                  pageName="Report Stabler"
                  urlEndpoint="/miscellaneous/pageconfig"
                  urlData={{ dictName: "PhantomTemplate" }}
                />
              </Modal>
            </>
          )}
        </>
      ) : (
        <>
          <Modal
            title={
              modalData["msgSuffixDataIndex"]
                ? action[modalMethod]["msgPrefix"] +
                  modalData["msgSuffixDataIndex"]
                : action[modalMethod]["msgPrefix"]
            }
            visible={isModalVisible}
            onOk={deleteYes}
            onCancel={() => setIsModalVisible(false)}
            okText="Yes"
            okButtonProps={{ loading: loading }}
            cancelText="No"
          >
          </Modal>
        </>
      )} */}
    </div>
  );
}

export default HModal;
